import { Col, Row, Space, Table } from 'antd';
import { EditButton, TextField, useTable } from '@refinedev/antd';
import { EyeOutlined } from '@ant-design/icons';
import { ICertifiers } from 'interfaces/certifiers';
import { ICourseCertificate } from 'interfaces/course_certificate';
import { ListLayout } from '../../../components/layout/layout/ListLayout';

export const CertifiersList = () => {
  const { tableProps } = useTable<ICertifiers>({});

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ListLayout title="Instituições Certificadoras">
          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="name"
              key="name"
              title="Nome"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="code"
              key="code"
              title="Código"
              render={value => <TextField value={value} />}
            />
            <Table.Column<ICourseCertificate>
              title="Ações"
              dataIndex="actions"
              align="center"
              width={80}
              render={(_, record) => {
                return (
                  <Space>
                    <EditButton
                      hideText
                      size="small"
                      icon={<EyeOutlined />}
                      recordItemId={record.id}
                    />
                  </Space>
                );
              }}
            />
          </Table>
        </ListLayout>
      </Col>
    </Row>
  );
};
